import { useState } from 'react';

const DTMF_KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];

export function usePlayDTMFSound() {
  const [pressedKey, setPressedKey] = useState('');

  /**
   * Plays a DTMF tone for the given key
   * @param {string} key - The key to play (must be one of: 1-9, *, 0, #)
   * @throws {Error} When audio file cannot be loaded or played
   * @returns {Promise<void>}
   * @example
   * play('1'); // Plays DTMF tone for key 1
   * play('#'); // Plays DTMF tone for hash key
   */
  const play = async (key) => {
    if (!DTMF_KEYS.includes(key)) {
      console.warn(
        `Invalid DTMF key: ${key}. Valid keys are: ${DTMF_KEYS.join(' ')}`
      );
      return;
    }

    try {
      setPressedKey(key);

      // TODO: Preload audio files for better performance
      // TODO: Use memorization to avoid re-importing audio files (e.g., useMemo for audioMap)
      let audioImport;

      if (key === '*') {
        audioImport = await import(`../assets/audios/dtmfs/dtmf_star.wav`);
      } else if (key === '#') {
        audioImport = await import(`../assets/audios/dtmfs/dtmf_hash.wav`);
      } else {
        audioImport = await import(`../assets/audios/dtmfs/dtmf_${key}.wav`);
      }

      const audio = new Audio(audioImport.default);
      await audio.play();
    } catch (error) {
      console.error(`Failed to load or play audio for key ${key}:`, error);
    }
  };

  return {
    dtmf: pressedKey,
    play
  };
}
